const taxes_types = [
  {text: 'Included in the price', value: 'include'},
  {text: 'Added to the price', value: 'exclude'},
]

const taxes_options = [
  {text: 'Apply the tax to the new items', value: 'new'},
  {text: 'Apply the tax to existing items', value: 'exist'},
  {text: 'Apply the tax to all new and existing items', value: 'all'},
  {text: '-', value: ''},
]

export default {
  taxes_types,
  taxes_options,
}
